import { Injectable, Renderer2, RendererFactory2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private renderer2: Renderer2;

  constructor(
    rendererFactory: RendererFactory2,
    @Inject(DOCUMENT) private _document,
  ) {
    this.renderer2 = rendererFactory.createRenderer(null, null);
  }

  displayLoader() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `showLoader()`;
    this.renderer2.appendChild(this._document.body, s);
  }

  hideLoader() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `hideLoader()`;
    this.renderer2.appendChild(this._document.body, s);
  }
}
